<template>
    <div class="about">
        <div class="about-bj">
            <div class="about-con">
                <div class="left">
                    <div class="aobutUs">ABOUT US <div class="border"></div>
                    </div>
                    <span>关于我们</span>
                    <span class="gs">A股上市公司全资控股 专业更值得信赖</span>
                    <div class="usText">
                        公司成立于2012年<br /><span>12年</span>电商代运营经验<br />累计服务超过<span>70W</span>商家<br />阿里妈妈<span>五星级服务商</span><br />蝉联<span>11届</span>阿里金牌淘拍档<br />荣获<span>3届</span>京东“京卓越奖”
                    </div>
                </div>
                <div class="right">
                    <div class="photo">
                        <img :src="imgId" alt="">
                    </div>
                    <div class="console">
                        <div class="top">
                            <div class="left" @click="imgChange(-1)">
                                <div class="left-sj"></div>
                            </div>
                            <div class="right" @click="imgChange(1)">
                                <div class="right-sj"></div>
                            </div>
                        </div>
                        <div class="bottom">
                            <span>{{ imgKey + 1 }}</span>&nbsp;
                            <span>/ {{ imgList.length }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="about-ry">
            <div class="about-ry-title">荣誉资质</div>
            <div class="about-ry-box">
                <div class="about-ry-imgslist" :style="`left: ${currentRyIndex * 600 * -1 + 380}px`">
                    <div class="about-ry-imgli" v-for="info in ryList" :key="info.url">
                        <img :src="info.url" class="about-ry-imgli-img" />

                        <div class="about-ry-imgli-imgtext">
                            {{ info.title }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="about-ry-page">
                <div class="about-ry-left" @click="reduceRpIndex">
                    &lt;
                </div>
                <div class="about-ry-right" @click="addRpIndex">
                    &gt;

                </div>
            </div>
        </div>

        <div class="about-gs">
            <div class="about-gs-title">发展历程</div>
            <div class="about-gs-box">
                <img src="@/assets/officialWebsiteImgs/aboutMMQT.png" class="about-gs-img">
                <div class="about-gs-right">
                    <div class="about-gs-right-li" v-for="fz, index in fzLists" :key="fz.info">
                        <div class="about-gs-right-yuan">

                        </div>
                        <div class="about-gs-right-info">
                            <span>{{ fz.time }}</span>
                            <span style="color:#939393;margin-left: 10px">{{ fz.info }}</span>
                        </div>
                        <div class="about-gs-right-line" v-if="index + 1 !== fzLists.length"></div>
                    </div>
                </div>
            </div>
        </div>

        <div class="adreess">
            <div class="adreess-con">
                <img src="https://static.maimiaotech.com/official_putin_h5/officialWebsiteImgs/local@2x.png" alt="">
                <span class="dz">公司地址：杭州市西湖区双龙街199号金色西溪B座4楼</span>
                <div class="line"></div>
                <img src="https://static.maimiaotech.com/official_putin_h5/officialWebsiteImgs/phone3@2x.png" alt="">
                <span>电 &emsp;&emsp;话 : 13588241409</span>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'about',
    data() {
        return {
            imgList: ['about1.png', 'about2.png', 'about3.png', 'about4.png'],
            imgId: require('@/assets/officialWebsiteImgs/about1.png'),
            imgKey: 0,
            fzLists: [
                {
                    time: '2024',
                    info: '京东京卓越服务商，正式上线Lazada自动投放软件-AIMAX省油宝'
                },

                {
                    time: '2023',
                    info: 'Shopee五星级服务商，抖店推广运营、跨境运营业务全面发展'
                },
                {
                    time: '2023',
                    info: '阿里妈妈m峰会“万相智链·先行生态伙伴'
                },
                {
                    time: '2023',
                    info: '天猫国际“年度超新星造星合作伙伴'
                },
                {
                    time: '2022',
                    info: '荣获淘宝服务市场最受欢迎流量推广工具，正式入驻成为京东京牌广告代理商，由浙江育英职业技术学院授牌”校外培训基地“，进军AIMAX、Shopee、阿里国际站等跨境电商平台'
                },
                {
                    time: '2021',
                    info: '荣获淘宝服务市场优秀淘拍档'
                },
                {
                    time: '2020',
                    info: '阿里妈妈万堂CLUB指定运营商。直播电商蓝海，扬帆起航'
                },

                {
                    time: '2020',
                    info: '阿里妈妈万堂CLUB指定运营商。直播电商蓝海，扬帆起航'
                },

                {
                    time: '2019',
                    info: '荣获阿里妈妈五星服务商，省油智推软件上线，拼多多优化软件上线'
                },

                {
                    time: '2018',
                    info: '服务奶牛奖，服务标杆奖'
                },

                {
                    time: '2017',
                    info: '荣获阿里妈妈最佳服务奖，钻展优化软件上线，京东优化软件上线'
                },

                {
                    time: '2015',
                    info: '齐心集团收购省油宝，人工托管服务上线'
                },
                {
                    time: '2013',
                    info: '省油宝首次荣获阿里妈妈金牌淘拍档，至今已蝉联8年'
                },
                {
                    time: '2012',
                    info: '公司注册成立，同年省油宝上线'
                },
            ],
            currentRyIndex: 0,
            ryList: [
                {
                    url: 'https://static.maimiaotech.com/official_putin_h5/officialWebsiteImgs/img_gw/ndcx_img.png',
                    title: '2023年度超新星'
                },
                {
                    url: 'https://static.maimiaotech.com/official_putin_h5/officialWebsiteImgs/img_gw/wxzl_img.png',
                    title: '万象智链'
                },
                {
                    url: 'https://static.maimiaotech.com/official_putin_h5/officialWebsiteImgs/addImg2023/honor2301.png',
                    title: '2022金牌淘拍档'
                },
                {
                    url: 'https://static.maimiaotech.com/official_putin_h5/officialWebsiteImgs/addImg2023/honor2302.png',
                    title: '2021金牌淘拍档'
                },
                {
                    url: 'https://static.maimiaotech.com/official_putin_h5/officialWebsiteImgs/img_gw/2020_yxtg.png',
                    title: '2020营销推广淘拍档'
                },
                {
                    url: 'https://static.maimiaotech.com/official_putin_h5/officialWebsiteImgs/img_gw/AMP_ndzx.png',
                    title: 'AMP年度拓新之星'
                },
                {
                    url: 'https://static.maimiaotech.com/official_putin_h5/officialWebsiteImgs/img_gw/2020_wtsy.png',
                    title: '2020万堂书院'
                },
                {
                    url: 'https://static.maimiaotech.com/official_putin_h5/officialWebsiteImgs/img_gw/2019_jpdd.png',
                    title: '2019金牌淘拍档'
                },
                {
                    url: 'https://static.maimiaotech.com/official_putin_h5/officialWebsiteImgs/img_gw/2018_jzyj.png',
                    title: '2018年京卓越奖'
                },
                {
                    url: 'https://static.maimiaotech.com/official_putin_h5/officialWebsiteImgs/img_gw/2018_czbq.png',
                    title: '2018浙江省软件行业成长型百强企业'
                },
                {
                    url: 'https://static.maimiaotech.com/official_putin_h5/officialWebsiteImgs/img_gw/2018_jzy.png',
                    title: '2018年度京卓越合作伙伴'
                },
                {
                    url: 'https://static.maimiaotech.com/official_putin_h5/officialWebsiteImgs/img_gw/2017_jzyj.png',
                    title: '2017年京卓越奖'
                },
                {
                    url: 'https://static.maimiaotech.com/official_putin_h5/officialWebsiteImgs/img_gw/zg_dsfq.png',
                    title: '中国电子商务服务业联盟发起单位'
                },
                {
                    url: 'https://static.maimiaotech.com/official_putin_h5/officialWebsiteImgs/img_gw/2017_fwnn.png',
                    title: '2017服务奶牛奖'
                },
                {
                    url: 'https://static.maimiaotech.com/official_putin_h5/officialWebsiteImgs/img_gw/2017_fwbg.png',
                    title: '2017服务标杆奖'
                },
                {
                    url: 'https://static.maimiaotech.com/official_putin_h5/officialWebsiteImgs/img_gw/2017_zyhz.png',
                    title: '2017年度京卓越合作伙伴'
                },
                {
                    url: 'https://static.maimiaotech.com/official_putin_h5/officialWebsiteImgs/img_gw/2016_jpdd.png',
                    title: '2016金牌淘拍档'
                },
                {
                    url: 'https://static.maimiaotech.com/official_putin_h5/officialWebsiteImgs/img_gw/2016_zjfw.png',
                    title: '2016最佳服务奖'
                },
                {
                    url: 'https://static.maimiaotech.com/official_putin_h5/officialWebsiteImgs/img_gw/2015.jpdd.png',
                    title: '2015金牌淘拍档',
                },
                {
                    url: 'https://static.maimiaotech.com/official_putin_h5/officialWebsiteImgs/img_gw/2015_sldsjc.png',
                    title: '2015思路电商杰出电商营销推广服务商',
                },
                {
                    url: 'https://static.maimiaotech.com/official_putin_h5/officialWebsiteImgs/img_gw/2015_zshy.png',
                    title: '2015年最受欢迎服务商',
                },
                {
                    url: 'https://static.maimiaotech.com/official_putin_h5/officialWebsiteImgs/img_gw/2014_jpdd.png',
                    title: '2014年金牌淘拍档',
                },
                {
                    url: 'https://static.maimiaotech.com/official_putin_h5/officialWebsiteImgs/img_gw/2014_jptpd.png',
                    title: '2014金牌淘拍档',
                },
                {
                    url: 'https://static.maimiaotech.com/official_putin_h5/officialWebsiteImgs/img_gw/2014_sljc.png',
                    title: '2014思路电商杰出电商流量推广服务奖',
                },
                {
                    url: 'https://static.maimiaotech.com/official_putin_h5/officialWebsiteImgs/img_gw/2013_jptpd.png',
                    title: '2013金牌淘拍档',
                },
                {
                    url: 'https://static.maimiaotech.com/official_putin_h5/officialWebsiteImgs/img_gw/2013_jppdch.png',
                    title: '2013下半年度直通车工具列淘金牌拍档称号',
                },
                {
                    url: 'https://static.maimiaotech.com/official_putin_h5/officialWebsiteImgs/img_gw/zj_rjxh.png',
                    title: '浙江省软件行业协会',
                },
                {
                    url: 'https://static.maimiaotech.com/official_putin_h5/officialWebsiteImgs/img_gw/2015_alimmrz.png',
                    title: '阿里妈妈营销拍档技能认证',
                },
                {
                    url: 'https://static.maimiaotech.com/official_putin_h5/officialWebsiteImgs/img_gw/2013_sljsdc.png',
                    title: '2013思路杰出电商直通车服务',
                },
                {
                    url: 'https://static.maimiaotech.com/official_putin_h5/officialWebsiteImgs/img_gw/2020.png',
                    title: '2020幼儿教育感谢证书',
                },
            ]
        }
    },
    methods: {
        imgChange(key) {
            this.imgKey = key + this.imgKey
            if (this.imgKey >= this.imgList.length) {
                this.imgKey = 0
            } else if (this.imgKey < 0) {
                this.imgKey = this.imgList.length - 1
            }
            this.imgId = require('@/assets/officialWebsiteImgs/' + this.imgList[this.imgKey])
        },
        addRpIndex() {
            if (this.currentRyIndex < 9) {
                this.currentRyIndex += 1
            }
        },
        reduceRpIndex() {
            if (this.currentRyIndex > 0) {
                this.currentRyIndex -= 1
            }
        }
    }

}


</script>
<style lang="less">
.about {
    width: 100%;
    padding-top: 60px;
    display: flex;
    align-items: center;
    flex-direction: column;

    &-gs {
        &-title {
            font-size: 40px;
            color: #3B426B;
            margin-top: 60px;
            margin-bottom: 40px;
        }

        &-box {
            display: flex;
        }

        &-img {
            width: 530px;
            height: 360px;
        }

        &-right {
            margin-left: 10px;

            &-li {
                display: flex;
                position: relative;
                margin-bottom: 36px;
                width: 800px;
            }

            &-yuan {
                flex-shrink: 0;
                width: 14px;
                height: 14px;
                background: #ffffff;
                border-radius: 50%;
                border: 3px solid #E0E0E0;
                position: relative;
                color: #282828;
                margin-right: 10px;
            }

            &-info {
                line-height: 18px;
            }

            &-line {
                width: 2px;
                height: 30px;
                background-color: rgba(0, 0, 0, 0.2);
                position: absolute;
                top: 16px;
                left: 6px;
            }
        }

    }

    &-bj {
        width: 1920px;
        height: 590px;
        display: flex;
        justify-content: center;

        .about-con {
            width: 1455px;
            height: 590px;
            background-color: aqua;
            background: url("~@/assets/officialWebsiteImgs/aboutbg@2x.png");
            background-size: contain;
            padding: 82px 136px 116px 180px;
            display: flex;
            justify-content: space-between;

            .left {
                display: flex;
                flex-direction: column;
                text-align: left;

                .aobutUs {
                    width: 130px;
                    font-size: 18px;
                    font-family: PingFang;
                    font-weight: 400;
                    color: #939393;
                    position: relative;
                    padding: 5px 0;

                    .border {
                        width: 15px;
                        height: 15px;
                        position: absolute;
                        top: 0;
                        right: 0;
                        border-top: 4px solid #4C5576;
                        border-right: 4px solid #4C5576;

                    }
                }

                &>span {
                    font-size: 30px;
                    font-family: PingFang;
                    font-weight: bold;
                    color: #2C87EE;
                }

                .gs {
                    font-size: 16px;
                    font-family: MicrosoftYaHei;
                    font-weight: 400;
                    color: #939393;
                    margin-top: 17px;
                }

                .usText {
                    margin-top: 58px;
                    font-size: 16px;
                    font-family: MicrosoftYaHei-Bold;
                    font-weight: bold;

                    span {

                        font-family: MicrosoftYaHei;
                        font-weight: 600;
                        color: #2C87EE;
                    }
                }
            }

            .right {
                display: flex;
                align-items: center;

                .photo {
                    background: #FAFAFA;
                    border-radius: 10px;

                    img {
                        width: 670px;
                        height: 340px;
                    }
                }

                .console {
                    height: 310px;
                    display: flex;
                    margin-left: 14px;
                    flex-direction: column;
                    justify-content: space-between;
                    align-items: flex-start;

                    .top {
                        display: flex;

                        .left,
                        .right {
                            width: 40px;
                            height: 40px;
                            background: #C4C4C4;
                            border-radius: 4px;
                            display: flex;
                            align-items: center;
                            justify-content: center;

                            &-sj {
                                width: 15px;
                                height: 15px;
                                margin-left: 5px;
                                border-top: 3px solid #fff;
                                border-left: 3px solid #fff;
                                transform: rotate(-45deg);
                            }
                        }

                        .left:hover,
                        .right:hover {
                            background-color: #2C87EE;
                        }

                        .right {
                            margin-left: 3px;

                            &-sj {
                                margin-right: 10px;
                                transform: rotate(130deg);
                            }

                        }
                    }

                    .bottom {
                        span {
                            font-size: 18px;
                            font-family: Arial;
                            font-weight: 400;
                            color: #ABABAB;
                        }

                        span:first-child {
                            font-size: 28px;
                            color: #2C87EE;
                        }
                    }

                }
            }
        }
    }

    .adreess {
        width: 1920px;
        background-color: #F7F7FA;

        &-con {
            height: 70px;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            margin-left: 370px;

            img {
                width: 15px;
                height: 16px;
                margin: 0 7px 0 47px;
            }

            img:first-child {
                width: 13px;
                height: 19px;
                margin-left: 0px;

            }

            .line {
                height: 14px;
                width: 1px;
                background-color: rgba(170, 170, 170, 0.575);
            }

            span {
                font-size: 15px;
                font-family: MicrosoftYaHei;
                font-weight: 400;
                color: #2D334B;
                margin-right: 47px;
            }

        }
    }

    &-ry {
        width: 100%;
        height: 550px;
        padding-top: 50px;
        background: url('https://static.maimiaotech.com/official_putin_h5/officialWebsiteImgs/img_gw/indexbg.png') no-repeat top left;
        background-size: 100% 100%;
        position: relative;
        overflow: hidden;

        &-title {
            padding-left: 380px;
            font-size: 20px;
            font-weight: bold;
            color: #FFFFFF;
            margin-bottom: 30px;
            text-align: left;
        }

        &-box {
            overflow: hidden;
        }

        &-imgslist {
            height: 260px;
            display: flex;
            position: absolute;
            top: 130px;
            left: 380px;
            transition: 0.3s ease all;
        }

        &-imgli {
            margin-right: 10px;
            flex-shrink: 0;
            padding: 0 20px;

            &-img {
                display: block;
                height: 206px;
                width: auto;
                margin: 0 auto;
            }

            &-imgtext {
                margin-top: 20px;
                font-size: 13px;
                color: #FFFFFF;
            }
        }

        &-page {
            padding-left: 380px;
            margin-top: 305px;
            display: flex;
        }

        &-left {
            width: 44px;
            height: 44px;
            background: #444343;
            color: #ffffff;
            font-size: 30px;
            margin-right: 2px;
            cursor: pointer;
        }

        &-right {
            width: 44px;
            height: 44px;
            background: #444343;
            color: #ffffff;
            font-size: 30px;
            cursor: pointer;
        }

    }
}
</style>